/** Meta Pixel solo sulla route landing (`/`). ID allineato a cantir-landing `META_PIXEL_ID`. */
export const CANTIR_FB_PIXEL_ID = '1835716533771629';

let bootstrapDone = false;
let initDone = false;

/** Stub ufficiale Meta + caricamento fbevents.js (stesso comportamento dello snippet in head). */
function ensureFacebookPixelStub(): void {
  const f = window as Window & { fbq?: unknown; _fbq?: unknown };
  if (f.fbq) return;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let n: any;
  n = f.fbq = function () {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, prefer-rest-params
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  s?.parentNode?.insertBefore(t, s);
}

/**
 * Chiamare solo dal mount di `LandingPage`: init una volta per sessione (tab), PageView a ogni visita della landing.
 */
export function trackCantirLandingFacebookPageView(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  if (!bootstrapDone) {
    bootstrapDone = true;
    ensureFacebookPixelStub();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fbq = (window as any).fbq as ((...args: unknown[]) => void) | undefined;
  if (typeof fbq !== 'function') return;

  if (!initDone) {
    fbq('init', CANTIR_FB_PIXEL_ID);
    initDone = true;
  }
  fbq('track', 'PageView');
}
